<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex a-center py-2">
			<div class="d-flex a-center" style="width: 370px;margin-right: 10px;">
				<div style="font-size: 10px;width: 120px;">发生日期：</div>
				<el-date-picker v-model="times" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">仓库：</div>
				<el-select v-model="ck_id" filterable style="width: 90%;" size="mini" @change="currk">
				    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">库：</div>
				<el-select v-model="ck_k" filterable style="width: 90%;" size="mini">
				    <el-option v-for="item in ckk" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 120px;">操作类型：</div>
				<el-select v-model="type" filterable style="width: 90%;" size="mini">
				    <el-option v-for="item in czdata" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div style="margin-left: auto;" class="d-flex a-center">
				<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
				<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
			</div>
		</div>
		
		
		<div style="height: 72vh;overflow-y: auto;">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;align-items: center;">
				<div style="width: 40%;">仓库 {{mrck}}</div>
				<div style="width: 40%;font-size: 24px;">库房吞吐量报表</div>
				<div style="width: 20%;"></div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 10px;margin-bottom: 10px;">
				<div style="width: 50%;">发生日期：{{times[0]}} - {{times[1]}}</div>
				<div style="width: 50%;">打印日期：{{today}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">发生日期</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">库房</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">客称</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">面积</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">数量</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">重量</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">操作类别</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in sjlist">
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.create_time}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.ckdatak.name}}</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">{{item.hwmx.hwmc}}</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">{{item.hwmx.kc}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.mj}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.js}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{(item.mjzl * item.js) / 1000}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{type == 0 ? '入仓' : type == 1 ? '加货' : '出仓'}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 10px;margin-bottom: 10px;">
				<div style="width: 33%;">合计面积：{{form.hjmj}}</div>
				<div style="width: 33%;">合计数量：{{form.hjjs}}</div>
				<div style="width: 33%;">合计重量：{{form.hjzl}}</div>
			</div>
		</div>
		
		
		<!-- 打印模板 -->
		<!-- <div class="print-div none" id="print_area" media="print">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 40%;"></div>
				<div style="width: 40%;font-size: 24px;">代付运费单</div>
				<div style="width: 20%;">{{dydd.hyfsdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 30%;">客户名称：{{dydd.khdata.name}}</div>
				<div style="width: 20%;">简称：{{dydd.khdata.j_name}}</div>
				<div style="width: 25%;">代付日期：{{dydd.qrhk_time}}</div>
				<div style="width: 25%;">单号：{{dydd.bh}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">供货方</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">件数</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">运费金额(元)</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">备注</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in dydd.djglhw">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.ghs}}</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.hwmc}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.num}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.yf}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.desc}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 33%;">合计件数：{{dydd.hjjs}}</div>
				<div style="width: 33%;">大写：{{dydd.jedx}}</div>
				<div style="width: 33%;">合计金额：<span style="margin-right: 4px;">{{dydd.zje}}</span>元</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 34%;display: flex;font-size: 13px;margin-bottom: 4px;">广州诚晖冷冻食品物流有限公司</div>
				<div style="width: 66%;display: flex;font-size: 13px;">电话：0757-85709188，85709200，85709201，17708636608</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;">
				<div style="width: 33%;">制单：{{dydd.cjrdata.name}}</div>
				<div style="width: 33%;">收款人：</div>
				<div style="width: 33%;">车牌号：</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	components: {
		buttonSearch
	},
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				hjmj:0,
				hjzl:0,
				hjjs:0
			},
			times:'',
			cklist:[],
			ck_id:'',
			ckk:[],
			ck_k:'',
			type:'',
			czdata:[
				{
					id:0,
					name:'入仓'
				},
				{
					id:1,
					name:'加货'
				},
				{
					id:2,
					name:'出仓'
				}
			],
			sjlist:[],
			mrck:'',
			today:''
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
		const moment = require('moment');
		const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
		this.today = currentTime
	},
	methods: {
		currk(val){
			let data = this.cklist.filter(item=>{
				return item.id == val
			})
			this.mrck = data[0].name
			
			
			
			this.axios.get('/admin/ckdjk?type='+this.ck_id, { token: true }).then(res => {
				this.ckk = res.data.data;
			});
		},
		// 清空筛选条件
		clearSearch() {
			this.times = ''
			this.ck_id = ''
			this.ck_k = ''
			this.type = ''
			this.ck_k = ''
		},
		// 搜索事件
		searchEvent() {
			console.log(this.times)
			let data = {
				ks_time:this.times[0],
				js_time:this.times[1],
				ck_id:this.ck_id,
				type:this.type,
				ck_k:this.ck_k
			}
			this.axios.post('/admin/bb/crls', data, {
				token: true
			}).then(res => {
				this.sjlist = res.data.data
				this.form = {
					hjmj:0,
					hjzl:0,
					hjjs:0
				}
				for(let i of this.sjlist){
					this.form.hjmj += parseFloat(i.mj)
					this.form.hjzl += Math.floor((parseFloat(i.mjzl) * i.js) / 1000)
					this.form.hjjs += i.js
					
				}
				this.form.hjmj = Math.floor(this.form.hjmj)
			})
		},
		
	}
};
</script>

<style>
	.container {
	  width: 400px;
	  height: 300px;
	  margin: 30px auto;
	  box-shadow: 0 0 2px gray;
	  padding: 20px;
	  overflow: scroll; 
	}
	
	.scroll {
	  width: 1400px;
	  height: 1300px;
	}
	
	.container::-webkit-scrollbar {
	  width: 10px;
	  height: 10px;
	}
	
	.container::-webkit-scrollbar-thumb {
	  background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-track {
	  background-color: #ddd;
	  border: 1px solid #ccc;
	}
	
	.container::-webkit-scrollbar-button {
	  background-color: #4d7fff;
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-button:hover {
	  background-color: #999999;
	}
</style>
